import { ViewerCountServiceOutput } from './ViewerCountServiceOutput';
export class ViewerCountService {
    static instance;
    output;
    constructor() {
        this.output = new ViewerCountServiceOutput();
    }
    async init() {
        // No initialization needed
    }
    static getInstance() {
        if (!ViewerCountService.instance) {
            ViewerCountService.instance = new ViewerCountService();
        }
        return ViewerCountService.instance;
    }
    static getNotificationInterface() {
        return ViewerCountService.getInstance();
    }
    static getOutput() {
        return ViewerCountServiceOutput.getReactiveOutput();
    }
    notifyViewerCountChangedForActiveStream(value) {
        this.output.setViewerForActiveBroadcast(value);
    }
}
